import { memo, useState } from "react";
// import Form from "react-bootstrap/Form";
import Switch from "react-switch";

import WithoutCashbackIcon from "../../Assets/SvgIcons/WithoutCashback";
import WithCashbackIcon from "../../Assets/SvgIcons/WithCashback";
import { priceDigitSeperator } from "../../Utils/Helpers";
import Colors from "../../Constants/Colors";
import "./styles.css";

const Item = (props) => {
  const { item, isSoftpos } = props;
  const [selected, setSelected] = useState(!!item.has_payment_reward);

  const onSwitchAction = (value) => {
    setSelected((prevState) => !prevState);
    props.onClick(value);
  };

  return (
    <div className="payment-switch w-100 d-flex justify-content-between my-3">
      <div>
        {item.has_payment_reward ? (
          <WithCashbackIcon color={Colors.green} />
        ) : (
          <WithoutCashbackIcon color={Colors.gray1} />
        )}
        <span className="payment-switch-title mr-1 text-black">
          {item.title}{" "}
          {!isSoftpos ? (
            <small className="payment-switch-toman">
              ({priceDigitSeperator(item.credit)} تومان)
            </small>
          ) : null}
        </span>
      </div>
      <Switch
        onChange={onSwitchAction}
        checked={selected}
        height={20}
        width={38}
        checkedHandleIcon={null}
      />
      {/* <Form.Check
                type="switch"
                id={`switch ${item.title}`}
                checked={selected}
                onChange={onSwitchAction}
            /> */}
    </div>
  );
};
export default memo(Item);
